import React, { useState, useEffect } from 'react';
import useAxiosPrivate from "./hooks/useAxiosPrivate"
import ExportSVG from './icon/ExportSVG'
import { downloadExcel } from "react-export-table-to-excel";
import Loading from "./Loading"
import { numberFormat} from './Investor'
import { Popup } from 'semantic-ui-react'
import RowChart from './util/RowChart'

function InvestmentHistory(props) {
    window.scrollTo(0, 0)
    document.title = "Nivesh Karma Gurus: Invest with the best";
    const [pageData, setpageData] = useState({});
    const [anuual, setAnnual] = useState(false);
    const [investorSymbol, setInvestorSymbol] = useState('');

    if (props.investor != investorSymbol) {
        setAnnual(false)
        setInvestorSymbol(props.investor)
    }

    const axiosPrivate = useAxiosPrivate();
    const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]


    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            console.log(a[property])
            console.log(b[property])
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/historical-holdings/" + props.investor + "?annual=" +anuual+"&access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        if (cdresponse.data.status === "Not Found") {
            setpageData({ dataNotFound: true })
            return
        }
        url = process.env.REACT_APP_BASE_URL + "/v1/current-holdings/" + props.investor + "?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponseTwo = await axiosPrivate.get(url);
        let sortData = []
        cdresponseTwo.data.holdings?.map(item => (
            sortData.push({ stock: item.stock_symbol})
        ))
        cdresponse.data.historical_rows?.forEach(matchItem => {
            const filteredData = sortData.filter(sData => sData.stock === matchItem.stock_symbol);
            if (filteredData.length === 0) {
                sortData.push({ stock: matchItem.stock_symbol })
            }
        })


        let tempData = JSON.parse(JSON.stringify(cdresponse.data))
        tempData.historical_rows = []
        let mapData = []
        cdresponse.data?.columns.forEach(itemRow => {
            let tempMapData = {}
            cdresponse.data.historical_rows?.forEach(matchItem => {
                tempMapData[matchItem.stock_symbol] = matchItem.data[itemRow]
            })
            tempMapData["date_header"] = itemRow
            tempMapData["ttm_indicator"] = false
            mapData.push(tempMapData)
        })
        sortData.forEach(sortItem => {
            cdresponse.data.historical_rows?.forEach(matchItem => {
                if (matchItem.stock_symbol === sortItem.stock) {
                    tempData.historical_rows.push(matchItem)
                }
            })
        })
        tempData["mapData"] = mapData
        setpageData(tempData)
    }

    function handleDownloadExcel() {

        let header = ["S. No.", "Stock Symbol", "Name", "% of Portfolio", "Activity", "Change", "Change%", "Shares", "Current Price", "Investment Value (Cr)", "52W Low", "52W High", "% Above 52W low", "Industry", "Sector"]
        let body = []

        pageData?.investments.forEach((item, index) => {
            let tempData = [index + 1]
            tempData.push(item.stock_symbol)
            tempData.push(item.name)
            tempData.push(item.pctOfProfile)
            tempData.push(item.activity)
            tempData.push(item.change)
            tempData.push(item.pctChange)
            tempData.push(item.share)
            tempData.push(item.currentPrice)
            tempData.push(item.investmentValue)
            tempData.push(item.low52)
            tempData.push(item.high52)
            tempData.push(item.pctAbove52WLow)
            tempData.push(item.industry)
            tempData.push(item.sector)
            body.push(tempData)
        })


        downloadExcel({
            fileName: "Investor",
            sheet: "Investor",
            tablePayload: {
                header,
                // accept two different data structures
                body: body,
            },
        });
    }

    const getUrl = (url) => {
        return "/Company/" + url
    }


    useEffect(() => {
        companyDetails()
    }, [props.investor, anuual, investorSymbol])

    return (
        <div>
            {Object.keys(pageData).length !== 0 &&
                <>
                <section className="optionsFinData">
                    <div className="leftAlign growthCompanyName" style={{ paddingLeft: "0px", fontWeight: "600" }}>
                        {pageData.shareholder_name}
                    </div>
                    <div className="rightAlign">
                        <div style={{display:"flex", columnGap:"40px"}}>
                            <div style={{ display: "flex", fontSize:"13px", cursor:"pointer", width: "180px"}}>
                                <div onClick={() => setAnnual(false)} style={anuual ? { backgroundColor: "rgb(221, 219, 240)", padding: "5px 10px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", width: "90px" } : { backgroundColor: "rgb(0, 0, 0)", padding: "5px 10px", color: "white", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", width: "90px"}}>Quarterly</div>
                                <div onClick={() => setAnnual(true)} style={!anuual ? { backgroundColor: "rgb(221, 219, 240)", padding: "5px 10px", borderTopRightRadius: "5px", borderBottomRightRadius: "5px", width: "90px" } : { backgroundColor: "rgb(0, 0, 0)", padding: "5px 10px", color: "white", borderTopRightRadius: "5px", borderBottomRightRadius: "5px", width: "90px"  }}>Annual</div>
                            </div>
                            <div className="optionButtonPrimary" onClick={handleDownloadExcel} style={{ cursor: "pointer" }}>
                                {// <ExportSVG />
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <div className="CompanyNav" style={{padding:"10px 0px"}}>

                    <div className="CompanyMenu" id="current" onClick={() => {
                        props.setNav('current')
                    }
                    } style={props.nav === "current" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Current</div>
                    <div className="CompanyMenu" id="Activity" onClick={() => {
                        props.setNav('Activity')
                    }
                    } style={props.nav === "Activity" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Activity</div>
                    <div className="CompanyMenu" id="History" onClick={() => {
                        props.setNav('History')
                    }
                    } style={props.nav === "History" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>History</div>

                </div>
                <div style={{ width: "100%", textAlign: "right", color: "#888", paddingBottom: "5px", fontSize: "11px" }}> The numbers are in percentages.</div>
                <div style={{backgroundColor: "white", borderRadius: "10px", padding: "10px 0px"}}>
                <table className="PeersTable finData" style={{backgroundColor:"white"}}>
                    <tbody>
                        <tr>
                                <td className="PeerColumnHeading PeerTabledataCenter">Stock</td>
                                <td></td>
                                {pageData?.columns?.map(item => (
                                    <td className="PeerColumnHeading PeerTabledataCenter" style={{ textAlign: "center"}}>{item}</td>
                                ))
                            }
                        </tr>
                    </tbody>
                    <tbody>
                        {pageData.historical_rows?.map((dataKey, index )=> (
                            <tr>
                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ textAlign: "left" }}><a href={getUrl(dataKey.stock_symbol)} target="_blank" style={{ textDecoration: "None" }}>{dataKey.stock_symbol}</a></td>
                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"}>
                                <div>
                                    <Popup
                                        className="popupChart"
                                            trigger={<img className="chartIcon" src={process.env.PUBLIC_URL + '/chart_Icon.png'} />}
                                            content={<RowChart mapkey={dataKey.stock_symbol} mapData={pageData.mapData} />}
                                        style={{ zIndex: "999" }}
                                    />
                                    </div>
                                </td>
                                {pageData.columns?.map(dataItem => (
                                    <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"}>{numberFormat(dataKey.data[dataItem])}</td>
                                    ))

                                }
                            </tr>
                        ))}
                            {(pageData.dataNotFound === true || pageData.historical_rows.length === 0 || pageData.historical_rows === undefined) &&
                                <tr>
                                <td colspan={pageData.columns?.length+2}>Data not found</td>
                                </tr>
                            }
                    </tbody>
                    </table>
                </div>
                </>
            } 
            {Object.keys(pageData).length === 0 &&
                <Loading />
            }
        </div>
    );
}

export default InvestmentHistory;